@if(isLoading()){
<app-skeleton-matches-list />
}

<!--  -->

@if(myMatches().length > 0){
<div class="flex flex-col gap-4">
  @for (match of myMatches(); track match.Id) {

  <app-match-favorite-item [data]="match" />
  }
</div>

} @else {
<app-no-result message="NotAvalaibleMatches" />

}
